import * as authApi from '../api/authApi';
import { clearSession, getSession, updateTokens } from './sessionStore';

/**
 * Odswieza token dostepu na podstawie zapisanego refresh tokena.
 *
 * Zwraca nowy token albo `null`, gdy sesji nie da sie odnowic — wtedy sesja
 * jest czyszczona, bo dalsze zadania i tak dostalyby 401.
 *
 * Uwaga na kontrakt backendu: `/api/auth/refresh` NIE rotuje refresh tokena
 * i zwraca `sessionId: null`. Dlatego zapisujemy wylacznie tokeny, zachowujac
 * identyfikator sesji z logowania.
 */
export async function refreshSession(): Promise<string | null> {
  const session = getSession();
  if (!session) return null;

  try {
    const response = await authApi.refresh(session.refreshToken);
    updateTokens(response.accessToken, response.refreshToken || session.refreshToken);
    return response.accessToken;
  } catch {
    clearSession();
    return null;
  }
}
